import React from "react";
import {useTranslation} from "react-i18next";
import {UseFormReturn} from "react-hook-form";
import {IGetCheckoutShippingOptionsData} from "../../../../typescript-library";
import ShippingOptionRow from "./ShippingOptionRow";
import styles from "./ShippingForm.module.scss";

export type IShippingFormData = {
  shippingOption: IGetCheckoutShippingOptionsData;
  phone?: string;
  shippingDate: string | null;
  isPartDeliveryAllowed: boolean;
};

const ShippingForm: React.FC<{
  filteredShippingOptions: IGetCheckoutShippingOptionsData[];
  methods: UseFormReturn<IShippingFormData>;
}> = ({filteredShippingOptions, methods}) => {
  const {t} = useTranslation(["errorcodes", "translations"]);

  const {
    formState: {errors},
    register,
    setValue,
    watch,
  } = methods;

  /*
  const showPartialDeliveryInput =
    checkout.cartData.positions.filter(
      (pos: ICartPosition) => pos.reference && pos.reference.itemId !== null && !!pos.item,
    ).length !== 1;
  */

  // Temporarily made invisible (FE-100503)
  const showPartialDeliveryInput = false;

  return (
    <React.Fragment>
      <div className={`${styles.radioGroup} ArrowBorder`}>
        {filteredShippingOptions.map((option) => {
          return (
            <ShippingOptionRow
              key={option.logisticsTypeId}
              option={option}
              selected={option.logisticsTypeId === watch().shippingOption?.logisticsTypeId}
              onShippingChanged={() => setValue("shippingOption", option)}
            />
          );
        })}
      </div>
      {watch("shippingOption").isPhoneRequired && (
        <div className={styles.inputWrapper}>
          <input
            type="tel"
            placeholder={t("form.phoneNumberForNotification") + " **"}
            {...register("phone", {required: true, maxLength: 50})}
          />
          {errors.phone && ["validate", "maxLength"].includes(errors.phone.type) && (
            <span>{errors.phone.message ? t(errors.phone.message) : t("form.typeInValidPhone")}</span>
          )}
          {errors.phone?.type === "required" && <span>{t("form.pleaseComplete")}</span>}
          <p className={styles.requiredMessage}>**&nbsp;{t("form.mandatory")}</p>
        </div>
      )}
      {showPartialDeliveryInput && (
        <div className={`${styles.inputWrapper} ArrowBorder`}>
          <label>
            <div>
              <input type={"checkbox"} {...register("isPartDeliveryAllowed")} />
            </div>
            <div>{t("checkout.partialDeliveryRequest")}</div>
          </label>
        </div>
      )}
    </React.Fragment>
  );
};

export default ShippingForm;
